import * as React from "react";

import styled from "@emotion/styled";
import colors from "../../Styles/colors";
import padding from "../../Styles/padding";
import { fontSize } from "../../Styles/text";

let Row = styled.div` 
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-gap: ${padding.small};

  @media (min-width: 900px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

let Option = styled.div`
  padding: ${padding.xlarge};
  background: #f2f2f2;
  text-align: center;

  :hover {
    background: ${colors.coreColor2};
  }

  & > p {
    margin: ${padding.large} 0;
    font-size: 20px;
    line-height: 36px;
  }

  a:first-of-type {
    margin-top: ${padding.large};
    font-size: 16px;
  }

  .theme-btn {
    margin-top: 24px;
  }


  @media (min-width: 900px) {
    :first-of-type {
      p:first-of-type {
        margin-top: 48px;
      }
    }
  }
`;

let Heading = styled.h3`
  margin-bottom: 0;
  font-size: 30px;
  font-weight: 800;
  color: ${colors.accent};
  line-height: 1;
`;

let SubHead = styled.div`
  margin: ${padding.standard} 0;
  color: ${colors.accentAccessible};
  font-size: 18px;
`;

let TextLink = styled.a`
  font-size: 16px;
  color: ${colors.coreColor1};
  text-decoration: underline;
  display: block;

  :visited {
    color: ${colors.coreColor1};
  }

  :focus, :active, :hover {
    color: ${colors.accentAccessible};
  }
`;

export default function StreamingOptions() {
  return <Row>
    <Option>
      <Heading>Livestream Our Channels</Heading>
      <p>
        TPT offers three channels for livestreaming: TPT 2, TPT KIDS, and TPT NOW. Available on you laptop, phone, or streaming device.
      </p>
      <a className="theme-btn" href="https://www.tpt.org/live/" target="_blank">
        Livestream now
      </a>
    </Option>
    <Option>
      <Heading>Watch On-Demand</Heading>
      <SubHead>Available Now</SubHead>
      <p>
        Stream shows for a limited time after premiering, plus extensive local content and more!
      </p>
      <a className="theme-btn" href="https://www.tpt.org/shows/" target="_blank">
        Stream online now
      </a>
    </Option>
    <Option>
      <Heading>Become a Member</Heading>
      <SubHead>Catch up &amp; binge entire seasons with TPT Passport</SubHead>
      <p>
        As a member benefit, TPT Passport provides extended access to thousands of shows and complete seasons.
      </p>
      <a className="theme-btn" href="https://www.tpt.org/getpassport/?pledge_code=AMW210901FS1" target="_blank">
        Get TPT Passport
      </a>
      <p>
        <TextLink href="https://www.tpt.org/sign-in/">Already a member? Sign in here</TextLink>
        <TextLink href="https://www.tpt.org/passport/">Learn more about TPT Passport</TextLink>
      </p>
    </Option>
  </Row>
}